/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { SummaryResult } from './SummaryResult'
import {
  SummaryResultFromJSON,
  SummaryResultFromJSONTyped,
  SummaryResultToJSON,
} from './SummaryResult'

/**
 *
 * @export
 * @interface ScaniaGetSummaryResponseWrapper
 */
export interface ScaniaGetSummaryResponseWrapper {
  /**
   *
   * @type {SummaryResult}
   * @memberof ScaniaGetSummaryResponseWrapper
   */
  scaniaGetSummary?: SummaryResult | null
  /**
   *
   * @type {string}
   * @memberof ScaniaGetSummaryResponseWrapper
   */
  error?: string | null
}

/**
 * Check if a given object implements the ScaniaGetSummaryResponseWrapper interface.
 */
export function instanceOfScaniaGetSummaryResponseWrapper(
  value: object,
): boolean {
  let isInstance = true

  return isInstance
}

export function ScaniaGetSummaryResponseWrapperFromJSON(
  json: any,
): ScaniaGetSummaryResponseWrapper {
  return ScaniaGetSummaryResponseWrapperFromJSONTyped(json, false)
}

export function ScaniaGetSummaryResponseWrapperFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ScaniaGetSummaryResponseWrapper {
  if (json === undefined || json === null) {
    return json
  }
  return {
    scaniaGetSummary: !exists(json, 'scania_get_summary')
      ? undefined
      : SummaryResultFromJSON(json['scania_get_summary']),
    error: !exists(json, 'error') ? undefined : json['error'],
  }
}

export function ScaniaGetSummaryResponseWrapperToJSON(
  value?: ScaniaGetSummaryResponseWrapper | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    scania_get_summary: SummaryResultToJSON(value.scaniaGetSummary),
    error: value.error,
  }
}
